'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './event-reservation-show.routes';

export class EventReservationShowComponent {
  constructor(Config, $stateParams, ReservableEventService, ReservationService, $uibModal, Auth, dialogs) {
    'ngInject';

    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.$uibModal = $uibModal;
    this.$stateParams = $stateParams;
    this.ReservationService = ReservationService;
    this.ReservableEventService = ReservableEventService;
    this.Auth = Auth;
    this.dialogs = dialogs;

    this.config = Config.getModuleConfig(Config.Modules.Reservation).getEventSettings();

    this.getData();
  }

  getData() {
    this.ReservableEventService.get({id: this.$stateParams.id}, event => {
      this.event = event;

      if (this.config[this.event.type] && this.config[this.event.type].hasOwnProperty("customSchema")) {
        this.customSchema = this.config[this.event.type].customSchema;
      }

      if (this.event.totalSpots) {
        this.ReservationService.getSpotsReserved({id: this.event._id}, data => {
          this.availableSpots = this.event.totalSpots - data.spotsReserved;
        })
      }

      this.ReservationService.getEventReservation({event: this.event._id, user: this.Auth.getCurrentUserSync()._id}, reservation => {
        this.reservation = reservation;
      })
    });
  }

  cancelReservation() {
    var that = this;

    var dlg = this.dialogs.confirm("Cancel Reservation?", "Do you really want to cancel your reservation?");
    dlg.result.then(() => {
      // OK delete it
      that.ReservationService.delete({id: this.reservation._id},
        () => {
          delete that.reservation;
          that.getData();
        },
        err => {
          alert("Could not cancel reservation");
        });
    }, () => {
      // Cancel
    });
  }

  openAddReservationModal() {
    var that = this;
    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reservationAdd',
      resolve: {
        config: function() {
          return {
            event: that.event,
            customSchema: that.customSchema
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (reservation) {
        reservation.type = that.event.type;
        that.ReservationService.save(reservation, _ => that.getData());
      },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.eventReservationShow', [uiRouter])
  .config(routes)
  .component('eventReservationShow', {
    template: require('./event-reservation-show.html'),
    controller: EventReservationShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/event/show/event-reservation-show.component.js